import { render, staticRenderFns } from "./msgList.vue?vue&type=template&id=73fcb1d2&scoped=true"
import script from "./msgList.vue?vue&type=script&lang=js"
export * from "./msgList.vue?vue&type=script&lang=js"
import style0 from "./msgList.vue?vue&type=style&index=0&id=73fcb1d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fcb1d2",
  null
  
)

export default component.exports